import React from 'react';

import AccreditedInvestorToaster from 'buyside/components/presentation/Toasters/accreditedInvestorToaster';
// import EventToaster from 'buyside/components/presentation/Toasters/eventToaster';
import JobApplicationToaster from 'buyside/components/presentation/Toasters/jobApplicationToaster';
import SideNavigation from 'buyside/components/presentation/MainSiteNavigation/SideNavigation/sideNavigation';
import SiteMessageToaster from 'buyside/components/presentation/Toasters/siteMessageToaster';
import TopNavigation from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/topNavigation';

import { persistentToast } from 'buyside/util/persistentToast';
// import { useIsEvent } from 'buyside/util/hooks/useWindowLocation';
import {
  Maybe,
  useMainNavigationCurrentUserQuery,
  useSiteMessageQuery
} from 'interfaces/graphql-typings';

import TrophyIcon from 'buyside/svgs/trophy.svg';

const MainSiteNavigation: React.FC<{
  currentUserFromRails: Maybe<any>;
}> = ({ currentUserFromRails }) => {
  const { data } = useMainNavigationCurrentUserQuery();
  const currentUser = data?.currentUser || currentUserFromRails;
  const {
    // canWriteIdeas,
    hasCompletedAccreditedInvestorProfile,
    profile,
    unaddressedApplicationsCount
  } = currentUser || {};

  const { data: siteMsgData } = useSiteMessageQuery();
  const siteMessage = siteMsgData?.latestSiteMessage;

  if (unaddressedApplicationsCount) {
    persistentToast(<JobApplicationToaster count={unaddressedApplicationsCount} />, {
      toastId: 'unaddressed-applications-toast',
      disableIndefiniteDismiss: true
    });
  }

  if (profile?.isAccredited && !hasCompletedAccreditedInvestorProfile) {
    persistentToast(<AccreditedInvestorToaster />, {
      toastId: 'accredited-investor-toast'
    });
  }

  if (siteMessage) {
    persistentToast(<SiteMessageToaster siteMessage={siteMessage} />, {
      toastId: `${siteMessage.id}-site-message-toast`,
      icon: siteMessage.isContest ? <TrophyIcon /> : undefined
    });
  }

  // if (!useIsEvent()) {
  //   persistentToast(<EventToaster />, {
  //     toastId: 'event-toast',
  //     disableIndefiniteDismiss: true
  //   });
  // }

  return (
    <>
      <TopNavigation currentUser={currentUser} />
      <SideNavigation currentUser={currentUser} />
    </>
  );
};

export default MainSiteNavigation;
